import Button from "../../../componentes/button/button";
import { acaoInfo } from "../../../utils/solicitacoes/statusConfig";

// A existência dos botões vem 100% de `acoes` (solicitacao.acoesDisponiveis, do backend).
// acaoInfo() só decide cor/ícone/texto — nunca se a ação existe ou não.
// Ações positivas (verde) sempre por último no grupo, ficando mais à direita.
function ordenarAcoes(acoes) {
    return [...acoes].sort((a, b) => {
        const pesoA = acaoInfo(a).variant === "green" ? 1 : 0;
        const pesoB = acaoInfo(b).variant === "green" ? 1 : 0;
        return pesoA - pesoB;
    });
}

export default function AcaoButtons({ acoes = [], onAcao, acaoEmExecucao, disabled = false }) {
    if (!acoes || acoes.length === 0) return null;

    return (
        <div className="flex flex-wrap gap-2 justify-end">
            {ordenarAcoes(acoes).map(acao => {
                const info = acaoInfo(acao);
                return (
                    <Button
                        key={acao}
                        variant={info.variant}
                        iconLeft={info.iconLeft}
                        label={info.label}
                        loading={acaoEmExecucao === acao}
                        disabled={disabled || (!!acaoEmExecucao && acaoEmExecucao !== acao)}
                        onClick={() => onAcao(acao)}
                    />
                );
            })}
        </div>
    );
}
